const CUSTOM_STYLES = {
  txtColor: "text-blue",
  accordionHeader: "text-light-grey",
  cntColor: "text-white",
  iconColor: "white",
  customClass: "clients-accordion",
  accord_open: "jaccord_open",
  accord_close: "jaccord_close",
};

const TITLE_STYLES = {
  title: "Answers to frequently asked questions",
  titleColor: "text-white",
};

const ARROW_STYLES = {
  bgColor: "bg-pink",
  strokeStyles: "[&>path]:fill-purple [&>path]:stroke-purple",
};

const SIGN = { color: "text-blue", value: "?" };

export { CUSTOM_STYLES, SIGN, TITLE_STYLES, ARROW_STYLES };
